import { DashboardFilterProvider } from "@/contexts/DashboardFilterContext";
import LeadActivityTable from "./LeadActivityTable";
import LeadListsTable from "./LeadListsTable";
import LeadQueueOverview from "./LeadQueueOverview";
import LeadRulesButton from "./LeadRulesButton";
import RejectedLeadsButton from "./RejectedLeadsButton";

/**
 * Leadlister-fanen (VIB-2988): ringeaktivitet per møtebooker og listene med statistikk.
 * Egen menynøkkel salgsmuligheter.leadlister, så de som ringer ikke ser dette.
 * VIB-3050: bookerkøene og reglene.
 */
export default function LeadListsTab() {
  return (
    <div className="space-y-8">
      <div className="flex justify-end gap-2">
        <LeadRulesButton />
        <RejectedLeadsButton />
      </div>
      <LeadQueueOverview />
      <DashboardFilterProvider>
        <LeadActivityTable />
      </DashboardFilterProvider>
      <LeadListsTable />
    </div>
  );
}
